export const rtlViewLang = [
  'ar',
  'ar-ae',
  'ar-bh',
  'ar-dz',
  'ar-dj',
  'ar-eg',
  'ar-eh',
  'ar-iq',
  'ar-jo',
  'ar-kw',
  'ar-lb',
  'ar-ly',
  'ar-ma',
  'ar-om',
  'ar-qa',
  'ar-sa',
  'ar-sd',
  'ar-so',
  'ar-sy',
  'ar-tn',
  'ar-td',
  'ar-ye',
  'dv',
  'dv-mv',
  'ar-mr',
  'ar-km',
  'ar-ps',
  'fa',
  'fa-ir',
  'fa-af',
  'he',
  'he-il',
  'ks',
  'ks-in',
  'ku-iq',
  'ps',
  'ps-af',
  'yi',
  'yi-il',
  'ur',
  'ur-pk',
  'ur-in',
];
